import axios from 'axios'

var SESSION_TOKEN_CACHE = { value: '' }

export async function setSessionToken() {
  try {
    if (SESSION_TOKEN_CACHE.value) return SESSION_TOKEN_CACHE.value
    const sessionResponse = await axios.get('/session-token')
    console.log('Session response:', sessionResponse.data)
    if (sessionResponse.data && sessionResponse.data.session_id) {
      SESSION_TOKEN_CACHE.value = sessionResponse.data.session_id
    }
  } catch (error) {
    console.error('Failed to initialize session token:', error)
    // Don't fail the auth process if session token fails
  }
}

export const getSessionToken = async () =>
  new Promise((resolve) => {
    if (SESSION_TOKEN_CACHE.value) return resolve(SESSION_TOKEN_CACHE.value)
    const timerID = setInterval(() => {
      if (SESSION_TOKEN_CACHE.value) {
        clearInterval(timerID)
        resolve(SESSION_TOKEN_CACHE.value)
      }
    }, 1000)
  })
